export default "__VITE_ASSET__0c9342f0__"